import { Location } from '@app/shared/routes';

const PrivacyPolicyLocation = new Location({ path: '/legal/privacy-policy' });

export { PrivacyPolicyLocation };
